import React from 'react';
import PropTypes from 'prop-types';
import classes from './layout.module.css';
import { makeStyles } from 'utils';

const styles = makeStyles(classes);

function Section({
    id,
    className,
    children,
    grow = false,
    variant,
    width = 'wide'
}) {
    return (
        <section id={id} className={styles(
            className,
            'section',
            grow && 'section--grow',
            variant === 'commands' && 'section--commands',
            width === 'small' && 'section--width-small')}>
            {children}
        </section>
    );
}

Section.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    grow: PropTypes.bool,
    variant: PropTypes.oneOf(['commands']),
    width: PropTypes.oneOf(['small', 'wide']),
}

Section.Command = ({ align, children }) => {
    return (
        <div className={styles('section__command', align === 'right' && 'section__command--align-right')}>
            {children}
        </div>
    );
}

Section.Command.propTypes = {
    align: PropTypes.oneOf(['left', 'right']),
};

export default Section;